import { applyDiscountCodeHeadless, applyStoreCreditHeadless, getCartHeadless, removeDiscountCodeHeadless, upsertCartAttributesHeadless, } from "@vendor-storefront-global/tokenGating/utils/cartUtils/cartOperations/headless/cartOps";
import { applyCartDiscountCodeOrGiftCardHosted, getCartHosted, removeDiscountCodeHosted, upsertCartAttributesHosted, } from "@vendor-storefront-global/tokenGating/utils/cartUtils/cartOperations/hosted/cartOps";
export async function getStorefrontCart(getCartIdentifierArgs) {
    if (getCartIdentifierArgs.isHeadless) {
        return await getCartHeadless(getCartIdentifierArgs.shopifyDomain, getCartIdentifierArgs.storefrontAccessToken);
    }
    return getCartHosted();
}
export async function upsertCartAttributes(cartAttributeUpdateArgs) {
    if (cartAttributeUpdateArgs.isHeadless) {
        return await upsertCartAttributesHeadless(cartAttributeUpdateArgs.shopifyDomain, cartAttributeUpdateArgs.storefrontAccessToken, cartAttributeUpdateArgs.cartAttributesToUpdate);
    }
    return await upsertCartAttributesHosted(cartAttributeUpdateArgs.cartAttributesToUpdate);
}
export async function applyCartDiscountCode(applyDiscountArgs) {
    if (applyDiscountArgs.isHeadless) {
        await applyDiscountCodeHeadless({
            shopifyDomain: applyDiscountArgs.shopifyDomain,
            storefrontAccessToken: applyDiscountArgs.storefrontAccessToken,
            discountCode: applyDiscountArgs.discountCode,
        });
    }
    else {
        await applyCartDiscountCodeOrGiftCardHosted(applyDiscountArgs.discountCode);
    }
}
export async function applyStoreCreditCode(applyDiscountArgs) {
    var _a;
    if (applyDiscountArgs.isHeadless) {
        await applyStoreCreditHeadless({
            shopifyDomain: applyDiscountArgs.shopifyDomain,
            storefrontAccessToken: applyDiscountArgs.storefrontAccessToken,
            storeCreditCode: applyDiscountArgs.storeCreditCode,
            onLoading: applyDiscountArgs.onLoading,
        });
    }
    else {
        (_a = applyDiscountArgs.onLoading) === null || _a === void 0 ? void 0 : _a.call(applyDiscountArgs);
        await applyCartDiscountCodeOrGiftCardHosted(applyDiscountArgs.storeCreditCode);
    }
}
export async function removeDiscountCode(removeDiscountArgs) {
    if (removeDiscountArgs.isHeadless) {
        await removeDiscountCodeHeadless(removeDiscountArgs.shopifyDomain, removeDiscountArgs.storefrontAccessToken);
    }
    else {
        await removeDiscountCodeHosted();
    }
}
